export default __webpack_public_path__ + "static/kjacobs-a4e7e1b2f07642283547a6bd4751fffd.png";